module.exports = __webpack_public_path__ + "img/body_back.585b3ccb.png";